import { styled as f, InputAdornment as w } from "@mui/material";
import O from "../../temp-lib/components/share/apeiron/ApeironTextField.js";
import { noForwardProps as R } from "../../temp-lib/util/styled/index.js";
import { RegexWholeNumber as k } from "../constants/regex.js";
import * as d from "ramda";
import { useMemo as c } from "react";
import { useTranslation as y } from "react-i18next";
import { jsx as x } from "react/jsx-runtime";
const $ = f(O, R)`
  .MuiInputBase-root {
    border-radius: 0px;
  }
  .MuiOutlinedInput-input {
    text-align: ${(r) => r.__adornment ? "right" : "center"};
  }
  .MuiFormHelperText-root {
    margin-right: 0px;
    text-align: right;
  }
  .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled {
    opacity: 0.65;
    -webkit-text-fill-color: white;
  }
`, q = f(w)`
  p {
    color: #808080;
  }
`, S = (r) => {
  const {
    endAdornment: n,
    errorMessage: m,
    inputProps: g,
    InputProps: e,
    max: h,
    min: v,
    remark: M,
    rules: _,
    startAdornment: b,
    unit: o,
    wholeNumber: a,
    reserveHelperTextSpace: A,
    ...I
  } = r, {
    t
  } = y(), s = c(() => n || (d.isNotNil(o) ? /* @__PURE__ */ x(q, {
    position: "end",
    children: o
  }) : null), [n, o]), N = c(() => {
    let i = {};
    return a && (i = d.assoc("pattern", k, i)), i;
  }, [a]), {
    className: u,
    ...T
  } = g || {}, P = {
    className: e != null && e.readOnly ? `Mui-disabled ${u}` : u,
    ...T
  }, F = {
    startAdornment: b,
    endAdornment: s,
    ...e
  }, p = h ?? 99999999, l = v ?? 0;
  return /* @__PURE__ */ x($, {
    __adornment: s,
    helperRemark: M,
    inputProps: P,
    InputProps: F,
    reserveHelperTextSpace: A,
    rules: {
      required: {
        value: !0,
        message: t("common.form_validation.required")
      },
      max: {
        value: p,
        message: t("common.form_validation.max", {
          max: p
        })
      },
      min: {
        value: l,
        message: t("common.form_validation.min", {
          min: l
        })
      },
      pattern: {
        value: /^[0-9]+$/g,
        message: t("common.form_validation.number_pattern")
      },
      ...N,
      ..._
    },
    ...m ? {
      helperText: m
    } : {},
    ...I
  });
};
export {
  S as default
};
//# sourceMappingURL=ApeironNumberTextField.js.map
